import { render } from "./ContSectionright.vue?vue&type=template&id=aa613c88&scoped=true"
import script from "./ContSectionright.vue?vue&type=script&lang=js"
export * from "./ContSectionright.vue?vue&type=script&lang=js"

import "./ContSectionright.vue?vue&type=style&index=0&id=aa613c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa613c88"]])

export default __exports__